/**
 * Helper function to group items by category for dropdowns
 * @param items Array of items with optional category property
 * @returns Array of grouped options with category labels
 */
export const groupByCategory = (items: any[]) => {
  if (!items || !Array.isArray(items)) {
    return []
  }

  const grouped = items.reduce((acc, item) => {
    const categoryName = item.category?.name || 'Autres'
    if (!acc[categoryName]) {
      acc[categoryName] = []
    }
    // Support different ID field names: id, industry_id, persona_id, etc.
    const itemId = item.id ?? item.industry_id ?? item.persona_id ?? item.value
    acc[categoryName].push({ label: item.name, value: itemId })
    return acc
  }, {})
  
  return Object.entries(grouped).map(([category, options]) => ({
    label: category,
    options: options
  }))
}

/**
 * Helper function to convert flat items to simple label/value format
 * @param items Array of items
 * @param people_translation
 * @returns Array of simple {label, value} objects
 */
export const toSelectOptions = (items: { name: string, min?: number, max?: number, [_: string]: any }[], people_translation: string) => {
  if (!items || !Array.isArray(items)) {
    return []
  }

  return items.map((item) => {
    let content = item.name
    // If min in not null and equal to 0 and we have a max
    if (item.min == 0 && item.max) {
      content += ` (<${Math.round(item.max)} ${people_translation || ''})`
    }
    // If we have a min and a max but min is not 0
    else if (item.min != null && item.max) {
      content += ` (${Math.round(item.min)}-${Math.round(item.max)} ${people_translation || ''})`
    }
    // If we have a min not equal to 0 but not a max
    else if (item.min && !item.max) {
      content += ` (${Math.round(item.min)}+ ${people_translation || ''})`
    }

    return { label: content, value: item.id }
  })
}